(ns journal-app-client.components.button
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [journal-app-client.utils.common :as common]
            [journal-app-client.components.icon :refer [angle-down]]
            [journal-app-client.utils.css :as css]))

(defn button [& argv]
  (let [[props children] (common/argv->props-children argv)
        loading? (or (:is-loading? props) (:loading? props))]
    (into
      [:button.button
       (merge
         (when (map? props)
           (dissoc props :loading? :is-loading? :ignore-brand-style?))
         {:class (str (:class props)
                   (when loading? " is-loading "))
          :aria-label "button"
          :disabled (or (:disabled props) loading?)})]
      children)))

(defn link [& argv]
  (let [[props children] (common/argv->props-children argv)
        loading? (or (:is-loading? props) (:loading? props))]
    (into
      [:button.is-clickable.is-link
       (merge
         (when (map? props)
           (dissoc props :loading? :is-loading? :ignore-brand-style?))
         {:class (str (:class props)
                   (when loading? " is-loading "))
          :aria-label "button"
          :style (merge {:padding "0.25em 0.75em"}
                   (:style props))
          :disabled (or (:disabled props) loading?)})]
      children)))

(defn default [& argv]
  (let [[props children] (common/argv->props-children argv)
        loading? (or (:is-loading? props) (:loading? props))]
    (if (or (= (or (:model props)) "split"))
      (into
        [button
         (merge
           (when (map? props)
             (dissoc props :loading? :is-loading? :model))
           {:class (or (:class props) " is-primary is-medium"
                     (when (= (or (:model props)) "split")
                       " is-rounded "))
            :style (merge
                     {:justify-content "space-around"
                      :margin "1.5vmin"
                      :color (or (get (:style props) "--c2")
                               "hsl(var(--scheme-main-hue), var(--scheme-main-saturation), var(--lightness-black-bis))")
                      :background (get (:style props) "--c1")
                      :width (or (get (:style props) "--w") (:width (:style props)) "14rem")
                      :height (or (get (:style props) "--h") (:height (:style props)))}
                     (:style props))})]
        children)
      [:button.default-button
       (when (map? props)
         (merge
           (dissoc props :loading? :is-loading? :model)
           {:key key
            :class (str (:class props)
                     (when loading? " is-loading "))
            :style (merge
                     {"--w" (:width (:style props))
                      "--h" (:height (:style props))
                      "--c2" (:color (:style props))
                      "--c1" (:background (:style props))}
                     (:style props))
            :aria-label "button"
            :disabled (or (:disabled props) loading?)}))
       (into [:div.default-button-inner]
         children)])))

(defn circular [& argv]
  (let [[props children] (common/argv->props-children argv)]
    (into
      [:button.default-button.circular
       (when (map? props)
         (assoc (dissoc props :loading?) :style (dissoc (:style props) :margin)))]
      children)))

(defn glowing-icon-button [& argv]
  (let [[props children] (common/argv->props-children argv)]
    [:a
     (merge
       (when (map? props)
         (dissoc props :icon :on-click :href :id :icon-props :disabled :button-style))
       {:style (merge
                 {:display "flex"
                  :align-items "center"
                  :padding "0"
                  :color "var(--text-strong)"}
                 (:style props))})
     (into
       [:button.simple-button.is-clickable.glows
        {:type "button"
         :class (:class props)
         :id (:id props)
         :href (:href props)
         :on-click (:on-click props)
         :aria-label (:aria-label props)
         :disabled (:disabled props)
         :style (merge
                  {:display "flex"
                   :align-items "center"
                   :justify-content "center"}
                  (:button-style props))}
        (when (:icon props)
          [:span.icon #_.badge.pulsate.badge-is-danger.badge-is-small
           (merge
             (:icon-props props)
             {:style (merge
                       (:style (:icon-props props))
                       {:box-shadow "none"})})
           [(if (keyword? (:icon props))
              (:icon props)
              :i)
            {:class (when (string? (:icon props)) (:icon props))}]])]
       children)]))

(defn hamburger [& [props]]
  (let [active? (or (:active? props) (:active? props))]
    [:button.is-clickable.glows.hamburger
     (merge
       (when (map? props) props)
       {:type "button"
        :aria-controls "navigation"
        :aria-expanded (if active? "true" "false")
        :class (str (:class props) (when active? " is-active "))
        :style {:width "3.5em"
                :height "3em"
                :margin "0.25em"
                "--is-clickable-drop-shadow-spread-1" "1.25em"
                "--is-clickable-drop-shadow-color-1" "var(--blue)"
                "--is-clickable-drop-shadow-spread-2" "0.5em"
                "--is-clickable-drop-shadow-color-2" "var(--blue)"}})
     [:span.hamburger-box
      [:span.hamburger-inner]]]))

(defn delete-cross-arrow [& [props]]
  (let [active? (or (:active? props) (:active? props))]
    [:button.is-clickable.glows.delete-cross.delete-cross-arrow
     (merge
       (when (map? props) (dissoc props :active? :active?))
       {:type "button"
        :aria-controls "navigation"
        :aria-expanded (if active? "true" "false")
        :class (str (:class props) (when-not active? " is-active "))
        :style (merge
                 {:width "3.5em"
                  :height "3em"
                  :margin "0.25em"}
                 (:style props))})
     [:span.delete-cross-box
      [:span.delete-cross-inner]]]))

(defn dynamic-menu-label [& argv]
  (let [[props children] (common/argv->props-children argv)]
    [:div
     (merge
       (when (map? props) (dissoc props :active?))
       {:style (merge
                 {:display "flex"
                  :align-items "center"
                  :padding-left "1em"
                  :padding-right "1em"}
                 (:style props))})
     (into
       [:p.menu-label
        {:style {:text-indent (if (:active? props) "initial" "-50rem")
                 :transition (css/style-transition "text-indent")
                 :overflow "hidden"}}]
       children)
     [:div
      {:style {:display (when (:active? props) "none")
               :background "var(--text-light)"
               :height "1px"
               :width "100%"}}]]))

(defn dynamic-ul [& argv]
  (let [[props children] (common/argv->props-children argv)]
    (into
      [:ul.is-collapsible
       (merge
         (when (map? props) (dissoc props :active?))
         {:style (merge {:margin-left  (if (:active? props) "2em" "1.15em")
                         :margin-right 0
                         :padding      0
                         :overflow     "hidden"}
                   (:style props))})]
      children)))

(defn dynamic-icon-label [& argv]
  (let [[props children] (common/argv->props-children argv)
        loading? (:loading? props)]
    [:button.simple-button.is-clickable
     {:type "button"
      :id (:id props)
      :title (:title props)
      :class (str (when loading? " is-loading ") (:class props))
      :href (:href props)
      :disabled (:disabled props)
      :on-focus (:on-focus props)
      :on-click (:on-click props)
      :style (merge {:display     "flex"
                     :align-items "center"
                     :padding     (if (and (:inner-icon-label? props) (not (:active? props)))
                                    "0.5rem"
                                    "0.5rem 0.5rem 0.5rem 1.35rem")
                     :transition  "transform var(--transition-duration) ease, padding var(--transition-duration) ease"}
               (:style props))
      }
     (when (:icon props)
       [:span.icon #_.badge.pulsate.badge-is-danger.badge-is-small
        (merge
          (:icon-props props)
          {:style (merge
                    (:style (:icon-props props))
                    {:box-shadow "none"})})
        [(if (keyword? (:icon props))
           (:icon props)
           :i)
         {:class (when (string? (:icon props)) (:icon props))}]])
     (into
       [:p
        {:style {:text-indent (if (:active? props) "initial" "-50rem")
                 :overflow "hidden"
                 :width "100%"
                 :display "flex"
                 :justify-content "space-between"
                 :align-items "center"
                 :text-align "start"
                 :padding-left "0.25rem"
                 :transition "text-indent calc(var(--transition-duration, 250ms)*1.5) ease"}}]
       children)]))

(defonce variables (r/atom {}))

(rf/reg-sub :dropdown
  (fn [_ [_ id]]
    (if id
      (get-in @variables [:dropdown id] nil)
      (:dropdown @variables))))

(defn toggle-dropdown [dropdown-key & [value]]
  (swap! variables assoc-in [:dropdown dropdown-key]
    (cond
      (false? value)
      false
      (true? value)
      true
      :else
      (not (get-in @variables [:dropdown dropdown-key] nil)))))

(defn dropdown [& argv]
  (let [[props children] (common/argv->props-children argv)
        dropdown-key (or (:dropdown-key props) (:id props) :default-dropdown-key)
        active? (get-in @variables [:dropdown dropdown-key] nil)]
    [:div.dropdown.is-active
     (dissoc props :button-label :trigger-props :button-props :dropdown-key :menu-style :content-style)
     [:div.dropdown-trigger
      (:trigger-props props)
      [button
       (merge
         {:aria-haspopup true
          :aria-controls (str dropdown-key "-menu")
          :on-click      (fn [event]
                           (when (fn? (:on-click (:button-props props)))
                             ((:on-click (:button-props props)) event))
                           (toggle-dropdown dropdown-key))}
         (dissoc (:button-props props) :on-click))
       (when (:button-label props)
         [:span (:button-label props)])
       [angle-down
        {:aria-hidden active?
         :active? active?}]]]
     [:div.dropdown-menu.is-right
      {:id (str dropdown-key "-menu")
       :style (:menu-style props)
       :role "menu"}
      (into
        [:div.dropdown-content.is-collapsible
         {:class (when-not active? "is-collapsed")
          :style (merge {:max-height "60svh"}
                   (:content-style props))}]
        children)]]))

(defn big-button [& [props]]
  [:button.simple-button.box.is-clickable
   {:class (:class props)
    :style    (merge {:display         "flex"
                      :align-items     "center"
                      :justify-content "end"
                      :flex-direction  "column"
                      :min-height      "8.75em"
                      :padding         "0"
                      :overflow        "hidden"
                      :border-radius   "1.5rem"
                      :font-size (:size props)}
                     (:style props))
    :on-click (:on-click props)}
   (when (:icon props)
     [:div
      {:style {:height           "100%"
               :display         "flex"
               :align-items     "center"}}
      [:div.box.is-rounded
       {:style {:padding "0"
                :margin  "0.5em"}}
       [:span.icon
        {:style {:font-size "2.25em"
                 :width     "2em"
                 :height    "2em"}}
        (:icon props)]]])
   (when (:title props)
     [:div
      {:style {:display         "flex"
               :align-items     "center"
               :justify-content "center"
               :flex-direction  "column"
               :text-align      "center"
               :width           "100%"
               :padding         "0.75em"
               :text-transform "capitalize"
               :background      "var(--scheme-main)"}}
      [:h1.title.is-4 (:title props)]])])

(defn tile-button [& [props]]
  [:div.tile.is-parent.is-vertical
   {:key (:key props)}
   [big-button (assoc props :class (str (:class props) " tile is-child "))]])